export default __webpack_public_path__ + "static/media/x33-logo.eda2aa59.png";